import { Component, HostBinding, Input } from '@angular/core';

@Component({
    standalone: false,
    selector: 'ziq-uses-visible-fields',
    templateUrl: './ziq-uses-visible-fields.component.html',
    styleUrls: ['./ziq-uses-visible-fields.component.scss']

})
export class ZIQUsesVisibleFieldsComponent {
    @Input()
    visibilityOptions: any;

    @HostBinding('class')
    readonly hostClass = 'ziq-uses-visible-fields';
}
